import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionTitleComponent } from '../../../shared/components/section-title/section-title.component';

@Component({
  selector: 'app-home-locations',
  standalone: true,
  imports: [CommonModule, SectionTitleComponent],
  templateUrl: './home-locations.component.html',
  styleUrls: ['./home-locations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeLocationsComponent {
  @Input() locations = [
    // {
    //   title: 'Pier J at Marina Del Sol',
    //   description:
    //     'Discover exclusive brokerage slips on pier J located within Marina Del Sol on Clear Lake. We offer twelve forty to fifty foot slips nestled within a quiet and community-oriented atmosphere. Experience the perfect blend of luxury and class on pier J at Marina Del Sol.',
    //   image: 'assets/images/home/locations/jmk5.jpg',
    // },
    {
      title: 'Pier 27 at Watergate Marina',
      description:
        'Set sail from the finest seat in the house. We offer an exclusive collection of seventeen (17) 40’ slips on pier 27 at Watergate Marina. Dredged to 8’ and with beautiful views of Clear Lake, pier 27 provides the perfect starting point for your adventures to both domestic and international waterways. Discover why pier 27 at Watergate Marina is the premier choice for your yachting needs.',
      image: 'assets/images/home/locations/watergate.jpg',
    },
  ];
}
